export default "__VITE_ASSET__Dyl8VaGk__"